module.exports = __webpack_public_path__ + "assets/quanpin.30c7f531d9dc1f8f27360fb9f845cd82.png";